import React from 'react'
// libs
import styled from 'styled-components'
// components
import { MaterialDesignContent, SnackbarProvider } from 'notistack'
// themes
import { colors } from 'themes/index'
// views
import { CircularProgressIcon } from './views'

// 'progress' is a custom variant: a snackbar with a loader for a running process
declare module 'notistack' {
  interface VariantOverrides {
    progress: true
  }
}

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: colors.green450
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: colors.purple400
  }
}))

// notistack has no own styles for a custom variant, so the colors are set without relying on its classes
const ProgressContent = styled(MaterialDesignContent)`
  && {
    color: ${colors.white100};
    background-color: ${colors.purple400};
  }
`

const anchorOrigin = {
  vertical: 'top' as const,
  horizontal: 'center' as const
}

const iconVariant = {
  progress: <CircularProgressIcon size={20} />
}

const styleOverrides = {
  info: StyledMaterialDesignContent,
  success: StyledMaterialDesignContent,
  progress: ProgressContent
}

const SnackbarProviderContainer = ({ children }) => (
  <SnackbarProvider
    maxSnack={3}
    preventDuplicate
    autoHideDuration={2000}
    iconVariant={iconVariant}
    Components={styleOverrides}
    anchorOrigin={anchorOrigin}>
    {children}
  </SnackbarProvider>
)

export default SnackbarProviderContainer
